<template>
  <v-card rounded="0" style="height: calc(100svh - env(safe-area-inset-bottom)); padding-top: env(safe-area-inset-top);">
    <v-layout style="height: 100%;">
      <v-navigation-drawer permanent rail color="primary">
        <div v-if="systemInformationData.CRMAgent && systemInformationData.CRMAgent.CRMAgentPermissions" class="d-flex flex-column fill-height">
          <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 60px;">
            <v-avatar size="x-small">
              <v-img :src="require('@/assets/images/appLogo.png')" draggable="false"></v-img>
            </v-avatar>
          </div>
          <template v-if="systemInformationData.CRMAgent.CRMAgentPermissions.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/token')?.CRMAgentPermissionValue == '1' && navigation.CRMToken">
            <v-list-item
              @click="null"
              @mousedown="startCRMTokenPress()"
              @mouseup="cancelCRMTokenPress()"
              @mouseleave="cancelCRMTokenPress()"
              @touchstart="startCRMTokenPress()"
              @touchend="cancelCRMTokenPress()"
              class="hoverableElement"
              style="display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;"
            >
              <v-icon style="margin: 5px 0px;">mdi-lock</v-icon>
              <p style="font-size: xx-small; margin-bottom: 5px;"><strong>{{ navigation.CRMToken.CRMTokenValue.slice(0, 2) }}-{{ navigation.CRMToken.CRMTokenValue.slice(2, 4) }}-{{ navigation.CRMToken.CRMTokenValue.slice(4, 6) }}</strong></p>
              <v-progress-linear
                :model-value="navigation.CRMToken.CRMTokenExpirationTime"
                max="120"
                height="4"
                :color="navigation.CRMToken.CRMTokenExpirationTime < 30 ? 'error' : (navigation.CRMToken.CRMTokenExpirationTime < 60 ? 'warning' : 'indigo')"
                style="margin-bottom: 5px; width: 40px;"
              ></v-progress-linear>
            </v-list-item>
          </template>
          <v-divider></v-divider>
          <v-list-item v-if="systemInformationData?.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/navigationDrawer/updateCRMAgentStatus')?.CRMAgentPermissionValue == '1'" @click="updateCRMAgentStatus()" class="hoverableElement">
            <v-icon :disabled="loader.updateCRMAgentStatus" :color="display.CRMAgentStatus == 'active' ? 'success' : 'error'" :class="display.CRMAgentStatus ? 'CRMAgentStatusIcon' : null">mdi-circle</v-icon>
          </v-list-item>
          <v-list-item v-if="systemInformationData?.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/navigationDrawer/SOUQAI')?.CRMAgentPermissionValue == '1'" @click="openAIAssistantDrawer()" class="hoverableElement">
            <v-icon>mdi-robot</v-icon>
          </v-list-item>
          <v-list-item v-if="systemInformationData?.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/navigationDrawer/productSearch')?.CRMAgentPermissionValue == '1'" @click="openProductSearchDrawer()" class="hoverableElement">
            <v-icon>mdi-shopping-search</v-icon>
          </v-list-item>
          <v-list-item v-if="systemInformationData?.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/navigationDrawer/map')?.CRMAgentPermissionValue == '1'" @click="openMapComponentDrawer()" class="hoverableElement">
            <v-icon>mdi-map</v-icon>
          </v-list-item>
          <v-divider></v-divider>
          <v-list density="compact" style="padding: 0; margin: 0;">
            <div v-for="navigationDrawerOption1 in navigation.navigationDrawerOptions" :key="navigationDrawerOption1">
              <v-list-item 
                v-if="navigationDrawerOption1.option.length != 0 && navigationDrawerOption1.option.some(option => option._hasPermission)" 
                @click="openMainNavigationBarOption(navigationDrawerOption1)"
                :class="navigationDrawerOption1.option.length != 0 && navigationDrawerOption1.option.some(option => option.route == $route.path) ? 'selectedVListItem selectedNavigationDrawerOption' : null"
                class="hoverableElement"
              >
                <v-icon>{{navigationDrawerOption1.icon}}</v-icon>
              </v-list-item>
              <v-list-item 
                v-else-if="navigationDrawerOption1.option.length == 0 && navigationDrawerOption1._hasPermission" 
                :prepend-icon="navigationDrawerOption1.icon" 
                class="hoverableElement"
              >
                <v-icon>{{navigationDrawerOption1.icon}}</v-icon>
              </v-list-item>
            </div>
          </v-list>
          <v-spacer></v-spacer>
          <v-divider></v-divider>
          <v-list density="compact" style="padding: 0; margin: 0;">            
            <v-list-item @click="toggleDarkMode()" class="hoverableElement">
              <v-icon class="rotate-icon">{{ theme.global.name.value == 'light' ? 'mdi-weather-sunny' : 'mdi-weather-night' }}</v-icon>
            </v-list-item>
            <v-list-item @click="toggleFullScreenMode()" class="hoverableElement">
              <v-icon>mdi-fullscreen</v-icon>
            </v-list-item>
            <v-list-item v-if="systemInformationData?.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/navigationDrawer/disableNotifications')?.CRMAgentPermissionValue == '1'" @click="updateCRMWhatsappMessageNotificationDisabled()" class="hoverableElement">
              <v-icon>{{ systemInformationData.CRMWhatsappMessageNotificationDisabled ? 'mdi-bell-off' : 'mdi-bell-ring' }}</v-icon>
            </v-list-item>
            <v-list-item @click="null" class="hoverableElement">
              <v-menu
                location="right"
                offset="10"
                :open-on-hover="true"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" @click="systemInformationData.volumeLevel = (systemInformationData.volumeLevel == 0) ? 100 : 0; updateVolumeLevel();" class="hoverableElement">{{ systemInformationData.volumeLevel == 0 ? 'mdi-volume-off' : (systemInformationData.volumeLevel < 33 ? 'mdi-volume-low' : (systemInformationData.volumeLevel < 66 ? 'mdi-volume-medium' : 'mdi-volume-high')) }}</v-icon>
                </template>
                <v-card color="primary" elevation="10" rounded="lg" min-width="200" style="overflow: hidden; top: -8px; padding: 5px;">
                  <v-slider
                    @update:model-value="updateVolumeLevel()"
                    v-model="systemInformationData.volumeLevel"
                    color="secondary"
                    :max="100"
                    :min="0"
                    :step="1"
                    hide-details
                  ></v-slider>
                </v-card>
              </v-menu>
            </v-list-item>
            <v-list-item @click="updateTooltipDisabled()" class="hoverableElement">
              <v-icon>{{ systemInformationData.tooltipDisabled ? 'mdi-tooltip' : 'mdi-tooltip-question' }}</v-icon>
            </v-list-item>
            <v-list-item @click="logout()" class="hoverableElement">
              <v-icon>mdi-logout-variant</v-icon>
            </v-list-item>
          </v-list>
          <div ref="version:Info" style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 10px;">
            <p style="font-size: 7px; cursor: default; user-select: none;">{{ navigation.frontendVersion }}</p>
          </div> 
        </div>
      </v-navigation-drawer>


      <v-navigation-drawer v-model="navigation.navigationDrawerIsVisible" temporary location="left" :width="$vuetify.display.smAndDown ? $vuetify.display.width : 450" color="primary">
        <div v-if="navigation.mainNavigationBarOption">
          <v-list-item :prepend-icon="navigation.mainNavigationBarOption.icon" style="height: 60px;">
            <p style="color: white; font-size: larger; cursor: default; user-select: none;"><strong>{{navigation.mainNavigationBarOption.title}}</strong></p>
          </v-list-item>
          <v-divider></v-divider>
          <v-list density="compact" style="padding: 0; margin: 0; user-select: none;">
            <div v-for="navigationDrawerOption in navigation.mainNavigationBarOption.option" v-bind:key="navigationDrawerOption">
              <div v-if="navigationDrawerOption._hasPermission">
                <v-list-item
                  v-if="navigationDrawerOption.option.length == 0"
                  @click="navigationDrawerOption.action ? openDialog(navigationDrawerOption.action) : $generalFunctions.default.navigateTo(navigationDrawerOption.route + (navigationDrawerOption.complete ? `/${systemInformationData[navigationDrawerOption.complete]}` : '')); navigation.navigationDrawerIsVisible = false;" 
                  :title="navigationDrawerOption.title" 
                  :class="navigationDrawerOption.route == $route.path ? 'selectedVListItem' : null"
                  class="hoverableText"
                >
                  <template v-slot:prepend>
                    <v-icon style="margin-right: 5px;">{{navigationDrawerOption.icon}}</v-icon>
                    <v-icon v-if="navigationDrawerOption.subicon" size="small">{{navigationDrawerOption.subicon}}</v-icon>
                  </template>
                </v-list-item>
                <v-list-group v-else>
                  <template v-slot:activator="{ props }">
                    <v-list-item v-bind="props" :title="navigationDrawerOption.title" class="hoverableText">
                      <template v-slot:prepend>
                        <v-icon style="margin-right: 5px;">{{navigationDrawerOption.icon}}</v-icon>
                        <v-icon v-if="navigationDrawerOption.subicon" size="small">{{navigationDrawerOption.subicon}}</v-icon>
                      </template>
                    </v-list-item>
                  </template>
                  <div v-for="navigationDrawerOption2 in navigationDrawerOption.option" v-bind:key="navigationDrawerOption2">
                    <v-list-item
                      v-if="navigationDrawerOption2._hasPermission"
                      @click="navigationDrawerOption2.action ? openDialog(navigationDrawerOption2.action) : $generalFunctions.default.navigateTo(navigationDrawerOption2.route + (navigationDrawerOption2.complete ? `/${systemInformationData[navigationDrawerOption2.complete]}` : '')); navigation.navigationDrawerIsVisible = false;" 
                      :title="navigationDrawerOption2.title" 
                      :class="navigationDrawerOption2.route == $route.path ? 'selectedVListItem' : null"
                      class="hoverableText"
                    >
                      <template v-slot:prepend>
                        <v-icon style="margin-right: 2px;">{{navigationDrawerOption2.icon}}</v-icon>
                        <v-icon v-if="navigationDrawerOption2.subicon" size="small" style="margin-right: 2px;">{{navigationDrawerOption2.subicon}}</v-icon>
                        <v-icon v-if="navigationDrawerOption2.subsubicon" size="x-small">{{navigationDrawerOption2.subsubicon}}</v-icon>
                      </template>
                    </v-list-item>
                  </div>  
                </v-list-group>
              </div>
            </div>
          </v-list>
        </div>
      </v-navigation-drawer>

      <v-navigation-drawer v-model="navigation.AIAssistantDrawerIsVisible" temporary location="left" :width="$vuetify.display.smAndDown ? $vuetify.display.width : 500" color="primary">
        <AIAssistant ref="AIAssistantComponent"></AIAssistant>
      </v-navigation-drawer>
      <v-navigation-drawer v-model="navigation.productSearchDrawerIsVisible" temporary location="left" :width="$vuetify.display.smAndDown ? $vuetify.display.width : 500" color="primary">
        <ProductSearchComponent ref="ProductSearchComponentInstance" :showUpdateStockButton="true"></ProductSearchComponent>
      </v-navigation-drawer>


      <v-navigation-drawer
        ref="mapComponentDrawer"
        v-model="navigation.mapComponentDrawerIsVisible"
        temporary
        location="left"
        :width="$vuetify.display.smAndDown ? $vuetify.display.width : 1000"
        color="primary"
      >
        <MapComponent
          :key="display.mapComponentDrawerInstanceKey"
          :width="display.mapComponentInstanceWidth"
          :height="display.mapComponentInstanceHeight"
          :showPoint="true"
          :showPointDrawPoint="true"
          :showPointDraggable="true"
          :displayMaps="
            systemInformationData.CRMLocalities.map(CRMLocality => ({
              mapID: CRMLocality.CRMLocalityID,
              mapName: CRMLocality.CRMLocalityName,
              mapColor: CRMLocality.CRMLocalityColor,
              mapFontColor: CRMLocality.CRMLocalityFontColor,
              mapCenterLatitude: CRMLocality.CRMLocalityMap.CRMLocalityMapCenterLatitude,
              mapCenterLongitude: CRMLocality.CRMLocalityMap.CRMLocalityMapCenterLongitude,
              mapPoints: CRMLocality.CRMLocalityMap.CRMLocalityMapPoints.map(p => ({
                mapPointLatitude: p.CRMLocalityMapPointLatitude,
                mapPointLongitude: p.CRMLocalityMapPointLongitude
              })),
              mapDivisions: CRMLocality.CRMLocalityMap.CRMLocalityMapDivisions.map(d => ({
                mapDivisionName: d.CRMLocalityMapDivisionName,
                mapDivisionDescription: d.CRMLocalityMapDivisionDescription,
                mapDivisionColor: d.CRMLocalityMapDivisionColor,
                mapDivisionIsDisplayOnly: d.CRMLocalityMapDivisionIsDisplayOnly,
                mapDivisionPoints: d.CRMLocalityMapDivisionPoints.map(dp => ({
                  mapDivisionPointLatitude: dp.CRMLocalityMapDivisionPointLatitude,
                  mapDivisionPointLongitude: dp.CRMLocalityMapDivisionPointLongitude
                }))
              }))
            }))
          "
          @showPointUpdate="handleShowPointUpdate"
        />
      </v-navigation-drawer>


      <v-main style="height: 100%; overflow-y: auto;">
        <router-view></router-view>
      </v-main>
    </v-layout>
  </v-card>
</template>

<style scoped>

  .selectedNavigationDrawerOption {
    border-inline-start: 5px solid #3F51B5;
  }


  @keyframes rotate {
    0% {transform: rotate(0deg)}
    100% {transform: rotate(360deg)}
  }
  .rotate-icon {
    animation: rotate 3s linear infinite; 
  }

  @keyframes pulse {
    0% { 
      transform: scale(1);
      filter: brightness(1);
    }
    50% { 
      transform: scale(1.1);
      filter: brightness(1.5);
    }
    100% { 
      transform: scale(1);
      filter: brightness(1);
    }
  }

  .CRMAgentStatusIcon {
    cursor: pointer;
    border-radius: 50%;
    padding: 4px;
    animation: pulse 3s ease-in-out infinite;
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
  }

</style>

<script setup>
  import { useTheme } from 'vuetify'
  const theme = useTheme();
  const storedTheme = localStorage.getItem('theme');
  theme.global.name.value = storedTheme || 'light';
  function toggleDarkMode(){
    const newTheme = theme.global.name.value == 'dark' ? 'light' : 'dark'
    theme.global.name.value = newTheme
    localStorage.setItem('theme', newTheme)
  }
</script>



<script>
  
  import { systemInformation } from '@/utilities/systemInformation';
  import websocket from '@/utilities/websocket';
  import AIAssistant from '@/components/AIAssistant.vue';
  import ProductSearchComponent from '@/components/ProductSearchComponent.vue';
  import MapComponent from '@/components/MapComponent.vue';
  export default {
    name: 'TopNavigationBar',
    inject: ['$generalFunctions', '$localStorageFunctions'],

    components: 
    {
      AIAssistant,
      ProductSearchComponent,
      MapComponent
    },

    data: () => 
    ({
      display: 
      {
        CRMAgentStatus: null,
        mapComponentDrawerInstanceKey: Math.random().toString(36).substring(2, 15),
        mapComponentInstanceWidth: 0,
        mapComponentInstanceHeight: 0
      },
      navigation: 
      {
        navigationDrawerIsVisible: false,
        AIAssistantDrawerIsVisible: false,
        productSearchDrawerIsVisible: false,
        mapComponentDrawerIsVisible: false,
        navigationDrawerOptions:
        [
          {
            'title': 'Conversaciones',
            'icon': 'mdi-chat',
            'value': null,
            'route': null,
            'action': null,
            'option': 
            [
              {
                'title': 'Conversaciones activas',
                'icon': 'mdi-chat',
                'subicon': 'mdi-arrow-right-bold',
                'value': '/chat',
                'route': '/chat',
                'action': null,
                'option': []
              },

              {
                'title': 'Lista de conversaciones',
                'icon': 'mdi-chat',
                'subicon': 'mdi-view-list',
                'value': '/CRMWhatsappConversations',
                'route': '/CRMWhatsappConversations',
                'action': null,
                'option': []
              },
              {
                'title': 'Agregar conversación',
                'icon': 'mdi-chat',
                'subicon': 'mdi-plus-circle',
                'value': '/injectCRMWhatsappConversationDialog',
                'route': null,
                'action': 'openInsertCRMWhatsappConversationDialog',
                'option': []
              }
            ]
          },

          {
            'title': 'Contactos',
            'icon': 'mdi-account-group',
            'value': null,
            'route': null,
            'action': null,
            'option': 
            [
              {
                'title': 'Lista de contactos',
                'icon': 'mdi-account-group',
                'subicon': 'mdi-view-list',
                'value': '/CRMWhatsappContacts',
                'route': '/CRMWhatsappContacts',
                'action': null,
                'option': []
              },
              {
                'title': 'Agregar contacto',
                'icon': 'mdi-account-multiple',
                'subicon': 'mdi-plus-circle',
                'value': '/insertCRMWhatsappContactDialog',
                'route': null,
                'action': 'openCRMWhatsappContactDialog',
                'option': []
              },
              {
                'title': 'Campañas de marketing',
                'icon': 'mdi-account-group',
                'subicon': 'mdi-bullhorn',
                'value': '/CRMWhatsappMarketingCampaigns',
                'route': '/CRMWhatsappMarketingCampaigns',
                'action': null,
                'option': []
              }
            ]
          },

          {
            'title': 'Órdenes',
            'icon': 'mdi-invoice-text',
            'value': null,
            'route': null,
            'option': 
            [
              {
                'title': 'Órdenes activas',
                'icon': 'mdi-invoice-text',
                'subicon': 'mdi-arrow-right-bold',
                'value': '/currentCRMWhatsappInvoices',
                'route': '/currentCRMWhatsappInvoices',
                'option': []
              },

              {
                'title': 'Lista de órdenes',
                'icon': 'mdi-invoice-text',
                'subicon': 'mdi-view-list',
                'value': '/CRMWhatsappInvoices',
                'route': '/CRMWhatsappInvoices',
                'option': []
              },
            ]
          },

          {
            'title': 'SINPE',
            'icon': 'mdi-cash-multiple',
            'value': null,
            'route': null,
            'option': 
            [
              {
                'title': 'SINPE activos',
                'icon': 'mdi-cash-multiple',
                'subicon': 'mdi-arrow-right-bold',
                'value': '/currentCRMWhatsappInvoicePayment',
                'route': '/currentCRMWhatsappInvoicePayment',
                'option': []
              },

              {
                'title': 'Lista de SINPE',
                'icon': 'mdi-cash-multiple',
                'subicon': 'mdi-view-list',
                'value': '/CRMWhatsappInvoicePayment',
                'route': '/CRMWhatsappInvoicePayment',
                'option': []
              }
            ]
          },

          {
            'title': 'Seguimientos',
            'icon': 'mdi-source-branch',
            'value': null,
            'route': null,
            'option': 
            [
              {
                'title': 'Seguimientos de contacto',
                'icon': 'mdi-source-branch',
                'subicon': 'mdi-account',
                'option': 
                [
                  {
                    'title': 'Generar seguimiento de contacto',
                    'icon': 'mdi-source-branch',
                    'subicon': 'mdi-account',
                    'subsubicon': 'mdi-plus-circle',
                    'value': '/insertCRMWhatsappContactFollowup',
                    'route': '/insertCRMWhatsappContactFollowup',
                    'option': []
                  },
                  {
                    'title': 'Lista de seguimientos de contacto',
                    'icon': 'mdi-source-branch',
                    'subicon': 'mdi-account',
                    'subsubicon': 'mdi-view-list',
                    'value': '/CRMWhatsappContactFollowups',
                    'route': '/CRMWhatsappContactFollowups',
                    'option': []
                  }
                ]
              },
              {
                'title': 'Seguimientos de producto',
                'icon': 'mdi-source-branch',
                'subicon': 'mdi-package',
                'value': null,
                'route': null,
                'option': 
                [
                  {
                    'title': 'Reporte de seguimientos de producto',
                    'icon': 'mdi-source-branch',
                    'subicon': 'mdi-package',
                    'subsubicon': 'mdi-chart-bar',
                    'value': '/CRMWhatsappProductFollowupSummary',
                    'route': '/CRMWhatsappProductFollowupSummary',
                    'option': []
                  },
                  {
                    'title': 'Lista de seguimientos de producto',
                    'icon': 'mdi-source-branch',
                    'subicon': 'mdi-package',
                    'subsubicon': 'mdi-view-list',
                    'value': '/CRMWhatsappProductFollowups',
                    'route': '/CRMWhatsappProductFollowups',
                    'option': []
                  }
                ]
              }
            ]
          },

          {
            'title': 'Control operativo',
            'icon': 'mdi-view-dashboard',
            'value': null,
            'route': null,
            'option': 
            [
              {
                'title': 'Dashboard',
                'icon': 'mdi-view-dashboard',
                'value': '/CRMDashboard',
                'route': '/CRMDashboard',
                'option': []
              },
              {
                'title': 'Ranking',
                'icon': 'mdi-podium-gold',
                'value': '/CRMRanking',
                'route': '/CRMRanking',
                'option': []
              },
              {
                'title': 'Ranking de entrega',
                'icon': 'mdi-podium-gold',
                'value': '/CRMShippingRanking',
                'route': '/CRMShippingRanking',
                'option': []
              },
              {
                'title': 'Tendencia de venta',
                'icon': 'mdi-package',
                'subicon': 'mdi-trending-up',
                'value': '/CRMProductSale',
                'route': '/CRMProductSale',
                'option': []
              }
            ]
          },
          {
            'title': 'Configuración',
            'icon': 'mdi-cog',
            'value': null,
            'route': null,
            'option': 
            [
              {
                'title': 'Mi perfil',
                'icon': 'mdi-cog',
                'subicon': 'mdi-account',
                'value': '/CRMAgent',
                'route': '/CRMAgent',
                'complete': 'CRMAgentID',
                'option': []
              },

              {
                'title': 'Agentes',
                'icon': 'mdi-cog',
                'subicon': 'mdi-briefcase-account',
                'value': ['/CRMAgents', '/CRMAgent/insertCRMAgent'],
                'route': null,
                'option': 
                [
                  {
                    'title': 'Lista de agentes',
                    'icon': 'mdi-cog',
                    'subicon': 'mdi-briefcase-account',
                    'subsubicon': 'mdi-view-list',
                    'value': '/CRMAgents',
                    'route': '/CRMAgents',
                    'action': null,
                  },
                  {
                    'title': 'Crear agente',
                    'icon': 'mdi-cog',
                    'subicon': 'mdi-briefcase-account',
                    'subsubicon': 'mdi-plus-circle',
                    'value': '/CRMAgent/insertCRMAgent',
                    'route': null,
                    'action': 'openCRMAgentDialog',
                  }
                ]
              },

              {
                'title': 'Localidades',
                'icon': 'mdi-cog',
                'subicon': 'mdi-store',
                'value': ['/CRMLocalities', '/CRMLocality/insertCRMLocality'],
                'route': null,
                'option': 
                [
                  {
                    'title': 'Lista de localidades',
                    'icon': 'mdi-cog',
                    'subicon': 'mdi-store',
                    'subsubicon': 'mdi-view-list',
                    'value': '/CRMLocalities',
                    'route': '/CRMLocalities',
                    'action': null,
                  },
                  {
                    'title': 'Crear localidad',
                    'icon': 'mdi-cog',
                    'subicon': 'mdi-store',
                    'subsubicon': 'mdi-plus-circle',
                    'value': '/CRMLocality/insertCRMLocality',
                    'route': null,
                    'action': 'openCRMLocalityDialog',
                  }
                ]
              },

              {
                'title': 'Catálogos multimedia',
                'icon': 'mdi-cog',
                'subicon': 'mdi-folder-multiple-image',
                'value': '/CRMWhatsappMediaCatalogs',
                'route': '/CRMWhatsappMediaCatalogs',
                'option': []
              },

              {
                'title': 'Shutdown',
                'icon': 'mdi-cog',
                'subicon': 'mdi-toggle-switch',
                'value': '/CRMShutdown',
                'route': null,
                'option': [],
                'action': 'openCRMShutdownDialog'
              }
            ]
          }
        ],
        mainNavigationBarOption: null,
        CRMToken: null,
        frontendVersion: null
      },
      loader:
      {
        updateCRMAgentStatus: false
      },
      interval:
      {
        CRMTokenPressInterval: null,
        CRMTokenExpirationInterval: null
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgentID: null,
        tooltipDisabled: false,
        volumeLevel: 0,
        CRMWhatsappMessageNotificationDisabled: false,
        CRMAgentStatus: null,
        CRMAgent: {},
        CRMAgents: [],
        CRMLocalities: []
      }
    }),

    methods: 
    {
      startCRMTokenPress() {
        this.interval.CRMTokenPressInterval = setTimeout(() => {
          this.refreshCRMToken()
          this.interval.CRMTokenPressInterval = null
        }, 600);
      },
      cancelCRMTokenPress() {
        if (this.interval.CRMTokenPressInterval) {
          clearTimeout(this.interval.CRMTokenPressInterval)
          this.$generalFunctions.default.copyToClipboardWithoutTitle(this, 'Token', 'o', this.navigation.CRMToken.CRMTokenValue);
        }
        this.interval.CRMTokenPressInterval = null
      },

      async selectCRMSystemToken(){
        const selectCRMSystemTokenRequestQuery =
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          }
        };
        const selectCRMSystemTokenResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAccount/functions/selectCRMSystemToken', selectCRMSystemTokenRequestQuery);
        if (selectCRMSystemTokenResult.success) {
          this.navigation.CRMToken = selectCRMSystemTokenResult.result;
          this.startCRMTokenExpirationInterval();
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMSystemToken_error', 'error', 'Ha ocurrido un error inesperado al consultar el token del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      },

      async refreshCRMToken(){
        const CRMTokenBackup = this.navigation.CRMToken;
        const refreshCRMTokenRequestQuery =
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          }
        };
        const refreshCRMTokenResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMToken/functions/refreshCRMSystemToken', refreshCRMTokenRequestQuery);
        if (refreshCRMTokenResult.success) {
          this.navigation.CRMToken = refreshCRMTokenResult.result;
          this.startCRMTokenExpirationInterval();
          this.$generalFunctions.default.copyToClipboardWithoutTitle(this, 'Token actualizado y', 'o', this.navigation.CRMToken.CRMTokenValue);
        } else {
          this.navigation.CRMToken = CRMTokenBackup;
          this.$root.notificationDialog.showSystemNotificationDialog('refreshCRMToken_error', 'error', 'Ha ocurrido un error inesperado al actualizar el token, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
      },


      startCRMTokenExpirationInterval(){
        if (this.interval.CRMTokenExpirationInterval) clearInterval(this.interval.CRMTokenExpirationInterval);
        this.interval.CRMTokenExpirationInterval = setInterval(() => {
          this.navigation.CRMToken.CRMTokenExpirationTime = this.navigation.CRMToken.CRMTokenExpirationTime - 1;
          if (this.navigation.CRMToken.CRMTokenExpirationTime <= 0){
            this.selectCRMSystemToken();
          }
        }, 1000);
      },






      openDialog(action){
        if (action == 'openCRMWhatsappContactDialog') this.$root.dialogComponent.openCRMWhatsappContactDialog(null, 'insert');
        if (action == 'openCRMLocalityDialog') this.$root.CRMLocalityDialog.openCRMLocalityDialog({'CRMLocality': null, 'deleteCRMLocality': false});
        if (action == 'openInsertCRMWhatsappConversationDialog') this.$root.dialogComponent.openInsertCRMWhatsappConversationDialog();
        if (action == 'openCRMShutdownDialog') this.$root.dialogComponent.openCRMShutdownDialog();
      
      },

      openAIAssistantDrawer(){
        this.navigation.AIAssistantDrawerIsVisible = !this.navigation.AIAssistantDrawerIsVisible;
        this.navigation.navigationDrawerIsVisible = false;
        this.navigation.productSearchDrawerIsVisible = false;
        this.navigation.mapComponentDrawerIsVisible = false;
        if (this.$refs.AIAssistantComponent) this.$refs.AIAssistantComponent.focusInput();
      },

      openProductSearchDrawer(){
        this.navigation.productSearchDrawerIsVisible = !this.navigation.productSearchDrawerIsVisible;
        this.navigation.navigationDrawerIsVisible = false;
        this.navigation.AIAssistantDrawerIsVisible = false;
        this.navigation.mapComponentDrawerIsVisible = false;
        if (this.$refs.ProductSearchComponentInstance) this.$refs.ProductSearchComponentInstance.focusInput();
      },

      openMapComponentDrawer(){
        this.navigation.mapComponentDrawerIsVisible = !this.navigation.mapComponentDrawerIsVisible;
        this.navigation.navigationDrawerIsVisible = false;
        this.navigation.AIAssistantDrawerIsVisible = false;
        this.navigation.productSearchDrawerIsVisible = false;
        if (this.$refs.mapComponentDrawer){
          this.display.mapComponentInstanceWidth = this.$refs.mapComponentDrawer.width + 'px';
          this.display.mapComponentInstanceHeight = window.innerHeight + 'px';
          this.display.mapComponentDrawerInstanceKey = Math.random().toString(36).substring(2, 15);
        }
      },
      
      logout(){
        this.$localStorageFunctions.default.wipe();
        systemInformation.wipe();
        this.$generalFunctions.default.navigateTo('/login');
      },

      toggleFullScreenMode(){
        if (!document.fullscreenElement) document.documentElement.requestFullscreen();
        else document.exitFullscreen();
      },

      updateCRMWhatsappMessageNotificationDisabled(){
        this.systemInformationData.CRMWhatsappMessageNotificationDisabled = !this.systemInformationData.CRMWhatsappMessageNotificationDisabled;
        systemInformation.setCRMWhatsappMessageNotificationDisabled(this.systemInformationData.CRMWhatsappMessageNotificationDisabled);
      },

      updateVolumeLevel(){
        systemInformation.setVolumeLevel(this.systemInformationData.volumeLevel);
      },

      updateTooltipDisabled(){
        this.systemInformationData.tooltipDisabled = !this.systemInformationData.tooltipDisabled;
        systemInformation.setTooltipDisabled(this.systemInformationData.tooltipDisabled);
      }, 

      openMainNavigationBarOption(mainNavigationBarOption){
        const previousMainNavigationBarOption = this.navigation.mainNavigationBarOption;
        this.navigation.mainNavigationBarOption = mainNavigationBarOption;
        this.navigation.navigationDrawerIsVisible = (!this.navigation.navigationDrawerIsVisible) || (previousMainNavigationBarOption != mainNavigationBarOption);
        this.navigation.AIAssistantDrawerIsVisible = false;
        this.navigation.productSearchDrawerIsVisible = false;
        this.navigation.mapComponentDrawerIsVisible = false;
      },

      async updateCRMAgentStatus() {
        this.loader.updateCRMAgentStatus = true;
        const updateCRMAgentStatusRequestQuery = 
        { 
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgentID
          },
          'CRMAgentStatus': this.display.CRMAgentStatus == 'active' ? 'inactive' : 'active'
        }
        this.display.CRMAgentStatus = this.display.CRMAgentStatus == 'active' ? 'inactive' : 'active';
        const updateCRMAgentStatusResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/functions/updateCRMAgentStatus', updateCRMAgentStatusRequestQuery);
        if (!updateCRMAgentStatusResult.success){
          this.display.CRMAgentStatus = this.display.CRMAgentStatus == 'active' ? 'inactive' : 'active';
          this.$root.notificationDialog.showSystemNotificationDialog('updateCRMAgentStatus_error', 'error', 'Ha ocurrido un error inesperado al actualizar el estado del agente, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
        this.loader.updateCRMAgentStatus = false;
      },
  
      async getSystemInformationData() {
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
            this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgentID = systemInformation.getCRMAgentID;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.volumeLevel = systemInformation.getVolumeLevel;
            this.systemInformationData.CRMWhatsappMessageNotificationDisabled = systemInformation.getCRMWhatsappMessageNotificationDisabled;
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      },

      handleWebsocket(){
        websocket.connectWebsocket();


        websocket.addWebsocketMessageListener('CRM_INACTIVE', () => {
          if (this.systemInformationData.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/CRMShutdown')?.CRMAgentPermissionValue != '1'){
            this.$localStorageFunctions.default.wipe();
            systemInformation.wipe();
            this.$generalFunctions.default.navigateTo('/login');
          }
        })

        if (this.systemInformationData.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/token')?.CRMAgentPermissionValue == '1'){
          websocket.addWebsocketMessageListener('/CRMToken/functions/refreshCRMSystemToken', 
            async (websocketMessageData) => {
              this.navigation.CRMToken = websocketMessageData.websocketMessageContent;
            }
          );
        }

        websocket.addWebsocketMessageListener('/CRMWhatsappConversation/CRMWhatsappConversationFeedback/functions/generateCRMWhatsappConversationFeedback', 
          async (websocketMessageData) => {
            this.$root.notificationDialog.showCRMWhatsappConversationFeedbackDialog(websocketMessageData.websocketMessageContent);
          }
        );
        
        websocket.addWebsocketMessageListener('/CRMWhatsappConversation/functions/requestCRMWhatsappConversationTransfer', 
          async (websocketMessageData) => {
            const systemNotificationDialogData = 
            {
              'CRMWhatsappConversationID': websocketMessageData.websocketMessageContent.CRMWhatsappConversationID,
              'CRMWhatsappConversationPhoneNumber': websocketMessageData.websocketMessageContent.CRMWhatsappConversationPhoneNumber,
              'CRMWhatsappContactID': websocketMessageData.websocketMessageContent.CRMWhatsappContactID,
              'CRMWhatsappContactFirstName': websocketMessageData.websocketMessageContent.CRMWhatsappContactFirstName,
              'CRMWhatsappContactMiddleName': websocketMessageData.websocketMessageContent.CRMWhatsappContactMiddleName,
              'CRMWhatsappContactFirstSurname': websocketMessageData.websocketMessageContent.CRMWhatsappContactFirstSurname,
              'CRMWhatsappContactSecondSurname': websocketMessageData.websocketMessageContent.CRMWhatsappContactSecondSurname,
              'sourceCRMAgentID': websocketMessageData.websocketMessageContent.sourceCRMAgentID,
              'sourceCRMAgentName': this.systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == websocketMessageData.websocketMessageContent.sourceCRMAgentID) ? this.systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == websocketMessageData.websocketMessageContent.sourceCRMAgentID).CRMAgentName : 'No registrado',
              'sourceCRMAgentColor': this.systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == websocketMessageData.websocketMessageContent.sourceCRMAgentID) ? this.systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == websocketMessageData.websocketMessageContent.sourceCRMAgentID).CRMAgentColor : 'primary',
              'sourceCRMAgentFontColor': this.systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == websocketMessageData.websocketMessageContent.sourceCRMAgentID) ? this.systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == websocketMessageData.websocketMessageContent.sourceCRMAgentID).CRMAgentFontColor : 'white',
              'sourceCRMAgentProfilePictureURL': this.systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == websocketMessageData.websocketMessageContent.sourceCRMAgentID) ? this.systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == websocketMessageData.websocketMessageContent.sourceCRMAgentID).CRMAgentProfilePictureURL : null
            };
            this.$root.notificationDialog.showSystemNotificationDialog(`requestCRMWhatsappConversationTransfer_${websocketMessageData.websocketMessageContent.CRMWhatsappConversationID}`, 'CRMWhatsappConversationTransfer', null, systemNotificationDialogData, true);
          }
        );

        websocket.addWebsocketMessageListener('/CRMWhatsappConversation/functions/processIncomingCRMWhatsappMessage', 
          async (websocketMessageData) => {
            if (this.$route.path == '/chat' || this.systemInformationData.CRMWhatsappMessageNotificationDisabled) return;
            this.$root.notificationDialog.showCRMWhatsappNotificationDialog({
              'CRMWhatsappMessageNotificationDialogCRMWhatsappConversationID': websocketMessageData.websocketMessageContent.CRMWhatsappConversationID,
              'CRMWhatsappMessageNotificationDialogCRMWhatsappMessageContextCRMWhatsappMessageID': websocketMessageData.websocketMessageContent.CRMWhatsappMessageID,
              'CRMWhatsappMessageNotificationDialogCRMWhatsappMessageContextCRMWhatsappMessageAPIID': websocketMessageData.websocketMessageContent.CRMWhatsappMessageAPIID,
              'CRMWhatsappMessageNotificationDialogCRMWhatsappConversationPhoneNumber': websocketMessageData.websocketMessageContent.CRMWhatsappConversationPhoneNumber,
              'CRMWhatsappMessageNotificationDialogCRMWhatsappContactName': websocketMessageData.websocketMessageContent.CRMWhatsappContactName,
              'CRMWhatsappMessageNotificationDialogCRMWhatsappMessageType': websocketMessageData.websocketMessageContent.CRMWhatsappMessageType,
              'CRMWhatsappMessageNotificationDialogCRMWhatsappTextMessageContent': websocketMessageData.websocketMessageContent.CRMWhatsappTextMessageContent
            });
          }
        );

        websocket.addWebsocketMessageListener('CRMAgentPermissionExpired', 
          async (websocketMessageData) => {
            if (this.systemInformationData.CRMAgent && this.systemInformationData.CRMAgent.CRMAgentPermissions && this.systemInformationData.CRMAgent.CRMAgentPermissions.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == websocketMessageData.websocketMessageContent.CRMAgentPermissionName)) {
              const CRMAgentPermission = this.systemInformationData.CRMAgent.CRMAgentPermissions.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == websocketMessageData.websocketMessageContent.CRMAgentPermissionName);
              if (CRMAgentPermission.CRMAgentPermissionName == 'Desactivar notificaciones') CRMAgentPermission.CRMAgentPermissionValue = '0';
            }
          }
        );

        websocket.addWebsocketMessageListener('/CRMAgent/functions/updateCRMAgentStatus', 
          async (websocketMessageData) => {
            if (this.systemInformationData.CRMAgent.CRMAgentID == websocketMessageData.websocketMessageContent.CRMAgentID) this.display.CRMAgentStatus = websocketMessageData.websocketMessageContent.CRMAgentStatus;
          }
        );

        websocket.addWebsocketMessageListener('/CRMAgent/functions/logout', 
          async () => {
            this.$localStorageFunctions.default.wipe();
            systemInformation.wipe();
            this.$generalFunctions.default.navigateTo('/login');
          }
        );
      },


      showPrivacyWarningDialog(){
        if (localStorage.getItem('privacyWarning') != 'true'){
          this.$root.privacyWarningDialog.openPrivacyWarningDialog();
        }
      }

    },

    async mounted(){
      this.navigation.frontendVersion = process.env.VUE_APP_FRONTEND_VERSION;
      await this.getSystemInformationData();
      if (this.systemInformationData.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/token')?.CRMAgentPermissionValue == '1'){
        this.selectCRMSystemToken();
      }

      
      if (this.systemInformationData.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/login')?.CRMAgentPermissionValue != '1'){
        this.$localStorageFunctions.default.wipe();
        systemInformation.wipe();
        this.$generalFunctions.default.navigateTo('/login');
      }

      if (this.systemInformationData.CRMAgent?.CRMAgentPermissions?.find(CRMAgentPermission => CRMAgentPermission.CRMAgentPermissionName == '/showPrivacyWarning')?.CRMAgentPermissionValue == '1'){
        this.showPrivacyWarningDialog();
      }
      
      
      this.display.CRMAgentStatus = this.systemInformationData.CRMAgent.CRMAgentStatus;
      this.handleWebsocket();
      this.navigation.navigationDrawerIsVisible = false;
      this.navigation.AIAssistantDrawerIsVisible = false;
      this.navigation.productSearchDrawerIsVisible = false;
      this.navigation.mapComponentDrawerIsVisible = false;

    const agentPermissions = this.systemInformationData?.CRMAgent?.CRMAgentPermissions || [];
    const agentPermissionValues = agentPermissions
      .filter(p => p.CRMAgentPermissionValue == '1')
      .map(p => p.CRMAgentPermissionName);

    // Función recursiva para validar opciones y subopciones
    function validateNavigationOptions(options) {
      if (!Array.isArray(options)) return;
      for (const option of options) {
        // Si value es un array, al menos uno debe estar en los permisos
        if (Array.isArray(option.value)) {
          option._hasPermission = option.value.some(val => agentPermissionValues.includes(val));
        } else if (typeof option.value == 'string') {
          option._hasPermission = agentPermissionValues.includes(option.value);
        } else {
          // Si no tiene value, pero tiene subopciones, se valida por subopciones
          option._hasPermission = false;
        }
        // Si tiene subopciones, validar recursivamente
        if (Array.isArray(option.option) && option.option.length > 0) {
          validateNavigationOptions(option.option);
          // Si alguna subopción tiene permiso, la opción padre también lo tiene
          if (option.option.some(sub => sub._hasPermission)) {
            option._hasPermission = true;
          }
        }
      }
    }

    validateNavigationOptions(this.navigation.navigationDrawerOptions);
    },

    beforeUnmount(){
      if (this.interval.CRMTokenPressInterval) clearInterval(this.interval.CRMTokenPressInterval);
      this.interval.CRMTokenPressInterval = null;
      if (this.interval.CRMTokenExpirationInterval) clearInterval(this.interval.CRMTokenExpirationInterval);
      this.interval.CRMTokenExpirationInterval = null;
    },

  }
</script>
